import { generatePath } from "react-router";

import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { DummyRoomEditContainer } from "@/components/features/items/edit/room/dummy/default/ui/existing";

import { useGetDummyRoomPageParams } from "./_hooks/use-get-dummy-room-page-params/use-get-dummy-room-page-params";

export const DummyRoomEditPage = () => {
	const { hotelID, roomID } = useGetDummyRoomPageParams();

	return (
		<PageMeta
			title="ダミー部屋の編集"
			url={generatePath(PATHS.HOTEL.ITEMS.ROOM.EDIT.ROOM_ID.DUMMY, { hotelID, roomID })}
		>
			<DummyRoomEditContainer hotelID={hotelID} roomID={roomID} />
		</PageMeta>
	);
};
